module.exports = __webpack_public_path__ + "img/two-green-snow.fa709007.svg";